export const parseSearchString = ( string ) => {
	if ( string === '' )
	{
		return {};
	}

	const handleProperty = ( property ) => {
		return /[=]/gu.test( property ) ? property : `${property}=yes`;
	};

	return JSON.parse( `{"${string.slice( 1 ).split( '&' ).map( handleProperty ).join( '&' ).replace( /&/gu, '","' ).replace( /[=]/gu, '":"' )}"}` );
};



//////////////////
// WEBPACK FOOTER
// ./utils/convertation/parseSearchString.js
// module id = LPCO
// module chunks = 12